import { authBaseURL } from './apiBaseUrl';
export const ADF_ENDPOINTS = {
  TRIGGER_PIPELINE: `${authBaseURL}/triggerPipeline`,
  LOG_HISTORY: `${authBaseURL}/historyLog`,
};
